export default {
  letterSpacing: 'var(--has-no-letter-spacing)',
  titleDotVisibility: 'block',
};
